import { createFileRoute } from '@tanstack/react-router';

import { MarketingTemplatesPage } from '../features/marketing/marketing-templates-page';
import '../styles/marketing-templates-v2.css';

export const Route = createFileRoute('/templates')({ component: MarketingTemplatesPage });
